import React, { useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image'

const Activites = () => {
    const [cultural, SetCultural] = useState(true)
    const [curricular, SetCurricular] = useState(false)
    const [classroom, SetClassroom] = useState(false)
    const [sports, SetSports] = useState(false)
    const [learning, SetLearning] = useState(false)
    const handleClick = (value) => {
        if (value === 1) {
            SetCultural(true)
            SetCurricular(false)
            SetClassroom(false)
            SetSports(false)
            SetLearning(false)
        } else if (value === 2) {
            SetCultural(false)
            SetCurricular(true)
            SetClassroom(false)
            SetSports(false)
            SetLearning(false)
        } else if (value === 3) {
            SetCultural(false)
            SetCurricular(false)
            SetClassroom(true)
            SetSports(false)
            SetLearning(false)
        } else if (value === 4) {
            SetCultural(false)
            SetCurricular(false)
            SetClassroom(false)
            SetSports(true)
            SetLearning(false)
        } else {
            SetCultural(false)
            SetCurricular(false)
            SetClassroom(false)
            SetSports(false)
            SetLearning(true)
        }
    }
    return (
        <div>
            <Container fluid className='Activites_Container pb-3 pt-2 mt-4'>
                <h3 className='text-center mb-5 text-white'>Our Activites</h3>
                <Row className='d-flex justify-content-center'  >
                    <Col xxl={8} xl={8} md={8} xs={8} lg={8} >
                        <p className='text-center text-white'>Our School Performs Many Activities Such as Cultural , Co-Curricular , Sports , Exhibition and many other like Youth Parliament to enhance the skill of Each student Very Deeply.</p>
                    </Col>
                </Row>
                <Row className='mt-5'>
                    <Col className='d-flex justify-content-center'>
                        <button onClick={(() => handleClick(1))} style={{ backgroundColor: cultural ? '#cd51e1' : '#f5f5f5' }} className='Activity_Button'>Cultural Activites</button>
                        <button style={{ backgroundColor: curricular ? '#cd51e1' : '#f5f5f5' }} onClick={(() => handleClick(2))} className='Activity_Button'>Co-Curricular Activites</button>
                        <button style={{ backgroundColor: classroom ? '#cd51e1' : '#f5f5f5' }} onClick={(() => handleClick(3))} className='Activity_Button'>Labs. & Library</button>
                        <button style={{ backgroundColor: sports ? '#cd51e1' : '#f5f5f5' }} onClick={(() => handleClick(4))} className='Activity_Button'>Sports</button>
                        <button style={{ backgroundColor: learning ? '#cd51e1' : '#f5f5f5' }} onClick={(() => handleClick(5))} className='Activity_Button'>Learnings</button>
                    </Col>
                </Row>
                {(cultural && (
                    <Row className='mt-5 d-flex justify-content-around'>
                        <Col md={4}>
                            <h4 className='text-white'>Cultural</h4>
                            <ul style={{ color: '#fff' }}>
                                <li className='mt-4'>Enhances creativity and artistic expression through dance, skits, and plays.</li>
                                <li className='mt-4'>Builds confidence and public speaking skills by performing in front of an audience.</li>
                                <li className='mt-4'>Fosters teamwork and collaboration during group performances and rehearsals.</li>
                                <li className='mt-4'>Promotes cultural awareness and appreciation by exploring different themes and traditions.</li>
                                <li className='mt-4'>Provides an outlet for students to express emotions and connect with others through the arts.</li>
                            </ul>
                        </Col>
                        <Col md={6}>
                            <Carousel fade>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Cultural-car (4).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Cultural-car (5).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Cultural-car (2).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Cultural-car (3).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Cultural-car (6).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Cultural-car (7).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Cultural-car (1).jpg')} />
                                </Carousel.Item>
                            </Carousel>
                        </Col>
                    </Row>
                ))}
                {(curricular && (
                    <Row className='mt-5 d-flex justify-content-around'>
                        <Col md={4}>
                            <h4 className='text-white'>Co-Curricular Activites</h4>
                            <ul style={{ color: '#fff' }}>
                                <li className='mt-4'>Fosters creativity and innovation through hands-on experiences like science exhibitions and art displays.</li>
                                <li className='mt-4'>Develops public speaking, leadership, and debating skills through platforms like Youth Parliament.</li>
                                <li className='mt-4'>Encourages teamwork and collaboration while participating in group activities and events.</li>
                                <li className='mt-4'>Boosts confidence and self-expression by showcasing students' talents and ideas.</li>
                                <li className='mt-4'>Provides a well-rounded education by integrating academic knowledge with practical, real-world applications.</li>
                            </ul>
                        </Col>
                        <Col md={6}>
                            <Carousel fade>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Co-curricular-car (1).jpeg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Co-curricular-car (1).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Co-curricular-car (2).jpeg')} />
                                </Carousel.Item>
                            </Carousel>
                        </Col>
                    </Row>
                ))}
                {(classroom && (
                    <Row className='mt-5 d-flex justify-content-around'>
                        <Col md={4}>
                            <h4 className='text-white'>Labs. & Library</h4>
                            <ul style={{ color: '#fff' }}>
                                <li className='mt-4' >Hands-on experiments in labs enhance practical understanding of scientific concepts.</li>
                                <li className='mt-4' >Encourages critical thinking and problem-solving skills through lab work.</li>
                                <li className='mt-4' >Access to diverse resources in the library promotes independent learning and research.</li>
                                <li className='mt-4' >Computer labs provide essential digital literacy and programming skills.</li>
                                <li className='mt-4' >Exposure to updated textbooks and journals improves knowledge and keeps students current with advancements in various fields.</li>
                            </ul>
                        </Col>
                        <Col md={6}>
                            <Carousel fade>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Labs&lib-car (1).jpeg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Labs&lib-car (1).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Labs&lib-car (2).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Labs&lib-car (3).jpg')} />
                                </Carousel.Item>
                            </Carousel>
                        </Col>
                    </Row>
                ))}
                {(sports && (
                    <Row className='mt-5 d-flex justify-content-around'>
                        <Col md={4}>
                            <h4 className='text-white'>Sports</h4>
                            <ul className='d-flex justify-content-center flex-column' style={{ color: '#fff' }}>
                                <li className='mt-4'>To Promote physical fitness and health.</li>
                                <li className='mt-4'>Enhances teamwork and social skills.</li>
                                <li className='mt-4'>Improves mental health and stress relief.</li>
                                <li className='mt-4'>Fosters discipline and time management.</li>
                                <li className='mt-4'>Increases overall academic performance.</li>
                                <li className='mt-4'>Big Playground To Play Sports Nicely</li>
                            </ul>
                        </Col>
                        <Col md={6}>
                            <Carousel fade>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/other Services (1).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Playground-Images (1).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/other Services (3).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Playground-Images (2).jpg')} />
                                </Carousel.Item>
                            </Carousel>
                        </Col>
                    </Row>
                ))}
                {(learning && (
                    <Row className='mt-5 d-flex justify-content-around'>
                        <Col md={4}>
                            <h4 className='text-white'>Learning</h4>
                            <ul style={{ color: '#ffffff' }}>
                                <li className='mt-4'>Holistic development of physical, mental, and emotional well-being.</li>
                                <li className='mt-4'>Strengthened connection between parents, teachers, and students for better support.</li>
                                <li className='mt-4'>Increased mindfulness and focus through yoga and prayers.</li>
                                <li className='mt-4'>Improved academic performance due to quality education.</li>
                                <li className='mt-4'>Modern Smart Class Which helps Students to Understand the Concepts very well.</li>
                            </ul>
                        </Col>
                        <Col md={6}>
                            <Carousel fade>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/PTInteraction (1).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/PTInteraction (2).jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Learning-car.jpg')} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <Image rounded fluid src={require('../../Images/Learning-car2.jpg')} />
                                </Carousel.Item>
                            </Carousel>
                        </Col>
                    </Row>
                ))}

            </Container>
        </div>
    )
}

export default Activites